import { Button } from "@mui/material";
import React from "react";
import DeleteIcon from '@mui/icons-material/Delete';

export default function ButtonDeleteProject(props) {

  const handleButtonClick = (e) => {
    // props.update(projectData);
    // setState(false);
    // props.setState(false);
  };

  return (
    <Button
      variant="outlined"
      color="inherit"
      disabled
      fullWidth
      onClick={handleButtonClick}
      startIcon={<DeleteIcon fontSize="small" />}
    >
      Delete Project
    </Button>
  );
}